import axios from 'axios'
import {API_URL} from '../constants';

const PROFILE_XI_API_URL = `${API_URL}/profile-xis`;

class ProfileXiService {

    fetchAllProfileXis() {
        const token = sessionStorage.getItem('token');
        return axios.get(`${PROFILE_XI_API_URL}/`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error);
            return [];
        });
    }

    fetchProfileXiById(id) {
        const token = sessionStorage.getItem('token');
        return axios.get(`${PROFILE_XI_API_URL}/${id}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error);
            return [];
        });
    }

    fetchProfileXiBy(page, pageSize, fromDate, toDate) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${PROFILE_XI_API_URL}/by`,  {page: page, pageSize: pageSize, fromDate: fromDate, toDate: toDate},
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error);
            return [];
        });
    }

    createProfileXi(profileXi){
        const token = sessionStorage.getItem('token');
        return axios.post(`${PROFILE_XI_API_URL}/create`,  profileXi,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error);
            return [];
        });
    }

    updateProfileXi(profileXi){
        const token = sessionStorage.getItem('token');
        return axios.post(`${PROFILE_XI_API_URL}/update`,  profileXi,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error);
            return [];
        });
    }

    deleteProfileXi(id){
        const token = sessionStorage.getItem('token');
        return axios.delete(`${PROFILE_XI_API_URL}/${id}`,  
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error);
            return [];
        });
    } 
}

export default new ProfileXiService();
